import Button from "components/EvtKit/button/Button"
import Modal from "components/EvtKit/modal/Modal"
import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import AttentionIcon from "components/icons/AttentionIcon"
import { useModal } from "hooks/useModal"
import useProductRequest from "pages/products/hooks/useProductRequest"
import { memo, useCallback } from "react"
import { changeModalState } from "reducers/products/products-actions"
import { useAppDispatch, useAppSelector } from "reducers/store"
import styled from "styled-components"

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ButtonContent = styled.div`
  display: flex;
  width: 160px;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const ButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
`

const UnpublishProductModal = () => {
  const appDispatch = useAppDispatch()

  const { isOpen, type, closeModal } = useModal()

  const { product } = useAppSelector((state) => state.product)

  const { onSubmit } = useProductRequest("updatePublished", closeModal, "Erro ao despublicar produto")

  const handleModalState = useCallback(() => {
    appDispatch(changeModalState(false, ""))
  }, [])

  const handleSubmit = useCallback(async () => {
    onSubmit()
  }, [onSubmit])

  return (
    <>
      <Modal openModal={isOpen && type === "unpublish"} closeModal={handleModalState} size="1-lg">
        <ModalContent>
          <IconContainer>
            <AttentionIcon />
            <Heading color="informative" variant="h4">
              Despublicar Produto
            </Heading>
          </IconContainer>
          <Heading variant="h6">{product.name}</Heading>
          <BodyText color="gray-dark" size="medium" weight="light" className="fill-width">
            A opção <b>'Não Publicado'</b> interrompe a venda do seu <b>Produto</b> na plataforma, mas você pode
            republicá-lo a qualquer momento sem afetar os usuários que já o estão utilizando.
          </BodyText>
          <BodyText size="medium" weight="bold">
            Tem certeza de que deseja continuar com esta ação?
          </BodyText>
          <ButtonContainer>
            <ButtonContent>
              <Button label="Sim" className={`fill-width secondary-attention`} onClick={handleSubmit} />
            </ButtonContent>
            <ButtonContent>
              <Button label="Não" className={`fill-width attention-attention`} onClick={closeModal} />
            </ButtonContent>
          </ButtonContainer>
        </ModalContent>
      </Modal>
    </>
  )
}

export default memo(UnpublishProductModal)
